<template>
	<layout-content>
		<div class="content" v-html="content" />
	</layout-content>
</template>

<script>
import { mapActions } from 'vuex'

export default {
	components: {},
	data() {
		return {
			content: '',
		}
	},
	computed: {
		page() {
			return `TermsAndConditions.${this.$i18n.locale}`
		},
	},
	watch: {
		page: {
			handler: 'updateContentPage',
			immediate: true,
		},
	},
	methods: {
		updateContentPage: function () {
			this.getContentPage({
				identifier: 'TermsAndConditions',
				languageCode: this.$i18n.locale,
			}).then((res) => {
				this.content = res.body
			})
		},
		...mapActions({
			getContentPage: 'content/getContentPage',
		}),
	},
}
</script>

<style scoped>
.content {
	padding-left: 1rem;
	padding-right: 1rem;
	max-width: 700px;
	margin: 0 auto;
}
.content >>> h1 {
	font-size: 1.2em;
}
</style>
